<template>
  <div
    class="page-section light-red-section"
    :style="{ backgroundColor: props.backgroundColor }"
  >
    <div class="icon-wrapper">
      <img
        src="../../../assets/red-connect-account.svg"
        alt="Connect account"
      >
    </div>
    <h1
      class="info-title red"
      :style="{ color: props.titleColor }"
    >
      <b>Insufficient account data</b>
    </h1>
    <p
      class="section-subtitle"
      :style="{ color: props.subtitleColor }"
    >
      The account you connected seems to have limited activity.
    </p>
    <p
      class="section-subtitle"
      :style="{ color: props.subtitleColor }"
    >
      <b>Connect your main account</b> or a more <b>active account</b>
      to get the full picture of your finances
    </p>
    <button
      class="blue-button"
      :style="{
        backgroundColor: props.buttonColor,
        color: props.buttonTextColor,
      }"
      @click="handleConnectAccountsClick"
    >
      Connect another account
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  backgroundColor: {
    type: String,
  },
  titleColor: {
    type: String,
  },
  subtitleColor: {
    type: String,
  },
  buttonColor: {
    type: String,
  },
  buttonTextColor: {
    type: String,
  },
});

const emit = defineEmits(['connectAccountsClick']);

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style lang="scss" scoped>
.page-section {
  padding: 40px 25px;
  font-family: 'SalaryFinance';
}

.light-red-section {
  background-color: #FFC1BF;
}

.icon-wrapper {
  margin-bottom: 15px;
  padding-left: 5px;
  img {
    width: 40px;
    height: 40px;
  }
}

.info-title {
  font-size: 25px;
  font-weight: 100;
  width: 90%;
  line-height: 1.2;
  margin-bottom: 20px;

  b {
    font-weight: 700;
  }
}

.red {
  color: #EF3C3C;
}

.section-subtitle {
  font-size: 16px;
  color: #012579;
  width: 90%;
  line-height: 1.5;
  margin-bottom: 30px;
  font-weight: 400;
}

.blue-button {
  background: #2C82FF;
  border-radius: 12px;
  color: white;
  padding: 17px 0;
  border: none;
  width: 90%;
  cursor: pointer;
  font-size: 18px;
  font-family: 'SalaryFinance';
  font-weight: 700;
}
</style>
